import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Loadable from 'react-loadable';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { withAuthGuard } from 'ggApp/modules/router/hocs';
import createPaymentsRoutes from 'ggApp/routes/payments';

const Loading = (): JSX.Element => <CircleLoader />;

const Wrap = Loadable({
    loader: () => import(/* webpackChunkName: "YourProfileWrap" */ './wrap'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const ProfileScreen = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "YourProfileScreen" */ 'ggApp/shared/screens/YourProfile/ProfileScreen'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const PersonalInformationView = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "PersonalInformationView" */ 'ggApp/shared/screens/YourProfile/PersonalInformationView'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const NotificationsView = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "NotificationsView" */ 'ggApp/shared/screens/YourProfile/NotificationsView'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const AccountSecurityView = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "AccountSecurityView" */ 'ggApp/shared/screens/YourProfile/AccountSecurityView'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const DevicesBrowsersView = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "DevicesBrowsersView" */ 'ggApp/shared/screens/YourProfile/DevicesBrowsersView'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const DeviceView = Loadable({
    loader: () =>
        import(/* webpackChunkName: "DeviceView" */ 'ggApp/shared/screens/YourProfile/DeviceView'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const CashScreen = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "GroverCashScreen" */ 'ggApp/shared/screens/GroverCash/CashScreen'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const GuardScreen = ({ children }: { children: React.ReactElement }): JSX.Element => (
    <React.Fragment>{children}</React.Fragment>
);

const YourProfileRoutes = (): JSX.Element => (
    <Route path="your-profile" component={withAuthGuard(GuardScreen)}>
        <Route component={Wrap}>
            <IndexRoute component={ProfileScreen} />
            <Route path="personal-information" component={PersonalInformationView} />
            <Route path="notifications" component={NotificationsView} />
            <Route path="account-security">
                <IndexRoute component={AccountSecurityView} />
                <Route path="devices-browsers">
                    <IndexRoute component={DevicesBrowsersView} />
                    <Route path=":deviceId" component={DeviceView} />
                </Route>
            </Route>
            <Route path="grovercash" component={CashScreen} />
        </Route>

        {createPaymentsRoutes()}
    </Route>
);

export default YourProfileRoutes;
